import { FormValues } from "@/pages/LoginPage/AdfsLoginForm/login-page.types";

export const initialValues: FormValues = {
    username: "",
    password: "",
    rememberMe: true,
};
